import React, { useState } from 'react';
import { t } from 'i18next';
import FinanceCarExpensesTable from './FinanceCarExpensesTable';
import FleetPanel, { FleetMode } from './FleetPanel';
import DriverLicensesPanel from './DriverLicensesPanel';
import SidePanel from '../util/SidePanel';

interface Props {
  rows: any[];
  access: any;
  staticDateCompany: any;
  onAdd: () => void;
  onEdit: (row: any) => void;
  refresh: () => void;
  baseUrl: string;
}

const CarExpensesSection: React.FC<Props> = ({ rows, access, staticDateCompany, onAdd, onEdit, refresh, baseUrl }) => {
  const [panel, setPanel] = useState<FleetMode | 'licenses' | null>(null);

  const canViewFleet     = access?.finance_fleet_view === true || access?.finance_fleet_view === 1;
  const canViewLicenses  = access?.finance_fleet_licenses === true || access?.finance_fleet_licenses === 1;
  const canEditLicenses  = access?.finance_fleet_add === true || access?.finance_fleet_add === 1;

  const toggle = (mode: FleetMode | 'licenses') => setPanel((cur) => (cur === mode ? null : mode));

  const toggleButtons = (
    <>
      {canViewFleet && (
        <>
          <button type="button" className={`dt-btn-ghost${panel === 'vehicles' ? ' active' : ''}`} onClick={() => toggle('vehicles')}>
            🚗 {t('CompanyVehicles') || 'Vehicles'}
          </button>
          <button type="button" className={`dt-btn-ghost${panel === 'insurance' ? ' active' : ''}`} onClick={() => toggle('insurance')}>
            🛡 {t('Insurance') || 'Insurance'}
          </button>
        </>
      )}
      {canViewLicenses && (
        <button type="button" className={`dt-btn-ghost${panel === 'licenses' ? ' active' : ''}`} onClick={() => toggle('licenses')}>
          🪪 {t('Licenses') || 'Licenses'}
        </button>
      )}
    </>
  );

  return (
    <>
      <div className="section-scroll">
        <FinanceCarExpensesTable
          rows={rows}
          access={access}
          staticDateCompany={staticDateCompany}
          baseUrl={baseUrl}
          onAdd={onAdd}
          onEdit={onEdit}
          refresh={refresh}
          panelToggle={toggleButtons}
        />
      </div>

      {/* fleet management (vehicles / insurance) */}
      <SidePanel open={panel === 'vehicles' || panel === 'insurance'} onClose={() => setPanel(null)} width={460}>
        {(panel === 'vehicles' || panel === 'insurance') && (
          <FleetPanel mode={panel as FleetMode} access={access} baseUrl={baseUrl} onClose={() => setPanel(null)} />
        )}
      </SidePanel>

      {/* driver licenses */}
      <SidePanel open={panel === 'licenses'} onClose={() => setPanel(null)} width={460}>
        {panel === 'licenses' && (
          <DriverLicensesPanel
            baseUrl={baseUrl}
            canEdit={canEditLicenses}
            onClose={() => setPanel(null)}
          />
        )}
      </SidePanel>
    </>
  );
};

export default CarExpensesSection;
